import {
  createActionTypes,
  createAsyncAction,
  createAsyncActionTypes,
} from '@dpdgroupuk/redux-action-creator';
import { StatusCodes } from 'http-status-codes';

import { apiService, fetchTimeoutHandler } from '../../../services';

export const ACTIONS = createActionTypes('DRIVER', {
  FETCH_DRIVER: createAsyncActionTypes('FETCH_DRIVER'),
  FETCH_DRIVER_FEEDBACK: createAsyncActionTypes('FETCH_DRIVER_FEEDBACK'),
});

export const fetchDriver = createAsyncAction(
  (driverCode: string, parcelCode: string) =>
    fetchTimeoutHandler(
      apiService.getDriverByDriverCode(driverCode, parcelCode)
    ).then(({ data }) => data),
  ACTIONS.FETCH_DRIVER
);

export const fetchDriverFeedback = createAsyncAction(
  (driverCode: string, parcelCode: string) =>
    fetchTimeoutHandler(
      apiService.getDriverFeedbackByDriverCode(driverCode, parcelCode)
    )
      .then(({ data }) => ({ ...data, driverCode }))
      .catch(error => {
        if (error.statusCode === StatusCodes.NOT_FOUND) {
          return {
            driverCode,
            feedback: [],
            compliments: {
              deliveredWithCare: 0,
              wentExtraMile: 0,
              friendlyManner: 0,
              respectedMyProperty: 0,
            },
          };
        }
        throw error;
      }),
  ACTIONS.FETCH_DRIVER_FEEDBACK
);
